<template>
  <div class="page gc">

    <div class="page-menu g3"><!--empty menu just for the space --></div>
    <div class="page-content g9">
      <h2>Settings</h2>
      <div class="accord" v-bind:class="{ 'closed': isClosed }">
        <header v-on:click="onToggle">Settings<span title="open / close"></span></header>
        <article v-if="!isClosed">
          <slot>
            <div class="grid-100w">

              <div class="input" v-for="setting in settings" :key="setting.settingId">
                <label>
                  <span> {{ setting.settingKey }}</span>
                  <input v-model="setting.settingValue" type="text"/>
                </label>

              </div>

            </div>
            <button type="button" class="left" v-on:click="saveAllSettings" v-bind:class="{ 'loading': isSaving }">
              Save
            </button>

            <button type="button" class="right" v-on:click="stopWebsite" v-bind:class="{ 'loading': isStopping }">
              Restart website
            </button>
            <div>
              {{ hasBeenStoppedMessage }}
            </div>
            <div>
              <div style="width:250px; float:right; text-align:right;margin-top:10px;"><p>Restarting website is
                necessary for some settings to take effect. Please note you must reload you browser and may need to
                login again.</p></div>
            </div>
          </slot>
        </article>
      </div>

      <div class="accord" v-bind:class="{ 'closed': createNewIsClosed }">
        <header v-on:click="onToggleNewSetting">New setting<span title="open / close"></span></header>
        <article v-if="!createNewIsClosed">
          <slot>
            <div class="grid-100w">
              <h4>
              Create a new setting here.
              </h4>
              <p>Please note this is stricly for admin/dev. Field can be boolean (1 or 0) or any other type fo setting. Settings cannot delete a setting.</p>
              <div class="input">
                <label>
                  <span> Setting value</span>
                  <input v-model="newSetting.settingValue" type="text"/>
                </label>
              </div>
              <div class="input">
                <label>
                  <span> Setting key</span>
                  <input v-model="newSetting.settingKey" type="text"/>
                </label>
              </div>


            </div>
            <button type="button" class="left" v-on:click="createNewSetting" v-bind:class="{ 'loading': isSaving }">
              Save
            </button>
          </slot>

        </article>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../../Api"
import FormBuilder from "../Components/FormBuilder.vue"
import Accord from "../Components/Accord.vue"
//import UUID from "vue-uuid"
import {mapState} from "vuex"

export default {
  components: {
    FormBuilder,
    Accord
  },
  data: () => ({
    settings: [],
    isLoading: false,
    isSaving: false,
    isClosed: false,
    createNewIsClosed: true,
    isStopping: false,
    hasBeenStoppedMessage: "",
    newSetting: {
      settingKey: "",
      settingValue: ""
    }

  }),

  mounted() {
    this.$store.dispatch("getSettingsList").then((res) => {
      this.settings = res;
    });

  },
  methods: {
    onToggle() {
      this.isClosed = !this.isClosed
    },
    onToggleNewSetting() {
      this.createNewIsClosed = !this.createNewIsClosed
    },
    saveAllSettings() {
      this.isSaving = true;
      this.$store.dispatch("saveSettings", this.settings).then((res) => {
        this.settings = res;
      });

      setTimeout(() => {
        this.isSaving = false;
      }, 600);
    },
    createNewSetting() {
      this.isSaving = true;
      this.$store.dispatch("createFirstSetting", this.newSetting).then(() => {
        this.$store.dispatch("getSettingsList").then((res) => {
          this.settings = res;

          setTimeout(() => {
            this.isSaving = false;
          }, 600);
        });
      });
    }
    ,
    stopWebsite() {
      this.isStopping = true;
      this.$store.dispatch("stopWebsite").then((res) => {

      });

      setTimeout(() => {
        this.isStopping = false;
      }, 600);

      this.hasBeenStoppedMessage = "Website have now been stopped. You must reload website with ctrl+r";
    }
  }
}
</script>
